import React from 'react'
import './footer.css';

const Footer = () => {
  return (
    <footer className='footer'>
      Copyright &#169; 2024 Onyejekwe Victor. All right reserved.
    </footer>
  )
}

export default Footer;
